// import './assets/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import 'sweetalert2/dist/sweetalert2.min.css'

import './assets/css/scrollbar.css'
import './assets/css/sidebar.css'
import './assets/css/atena.css'
import './assets/css/transitions.css'
import './assets/css/mobile-footerbar.css'
import './assets/css/custom-sweetalert.css'
import './assets/css/custom-multiselect.css'

import DefaultLayout from './layouts/DefaultLayout.vue'
import EmptyLayout from './layouts/EmptyLayout.vue'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from "@sentry/vue";

import App from './App.vue'
import router from './router'
import 'bootstrap'

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://b5efd7d9c7fbcd73d16e84ba92864500@o4507855041593344.ingest.us.sentry.io/4507896572936192",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.browserProfilingIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Profiling
    profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
});

app.use(createPinia())
app.use(router)

app.component('default-layout', DefaultLayout)
app.component('empty-layout', EmptyLayout)

app.mount('#app')

